import { html } from 'lit';

export default (id: number) =>
    html`<span part="icon">
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" height="24" width="24">
            <defs>
                <clipPath id="theoplayer-chromecast-rings-mask-${id}">
                    <path d="M0-36h44V0H0z" />
                </clipPath>
            </defs>
            <path class="theoplayer-chromecast-outer" d="M2 10a4 4 0 0 1 4-4h36a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H28v-4h14V10H6v6H2z" />
            <path class="theoplayer-chromecast-inner" d="M10 14h28v20H26.74A26 26 0 0 0 10 17.26z" />
            <g
                class="theoplayer-chromecast-rings"
                fill="none"
                stroke="currentColor"
                stroke-width="4"
                transform="translate(2 42)"
                clip-path="url(#theoplayer-chromecast-rings-mask-${id})"
            >
                <circle stroke="none" cx="0" cy="0" r="30" />
                <circle class="theoplayer-chromecast-ring theoplayer-chromecast-ring1" stroke-width="6" cx="0" cy="0" r="3" />
                <circle class="theoplayer-chromecast-ring theoplayer-chromecast-ring2" cx="0" cy="0" r="12" />
                <circle class="theoplayer-chromecast-ring theoplayer-chromecast-ring3" cx="0" cy="0" r="20" />
                <path class="theoplayer-chromecast-ring theoplayer-chromecast-ring4" stroke-linecap="round" d="M0-20A20 20 0 0 1 20 0" />
            </g>
        </svg>
    </span>`;
